import React from "react";
import Navbar from "./components/Navbar";
import About from "./components/About";
import { Routes, Route } from "react-router-dom";

function Homepage() {
  return (
    <Routes>
      <Route path="/" element={<Navbar />} />
      <Route path="/about" element={<About />} />
    </Routes>
  );
}

export default Homepage;
